module.exports = __webpack_public_path__ + "components/flag/static/square/co-c80401dc48d571e7898c464b09d355ae.svg";